import React from 'react';
import { MenuItem, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { SYSTEM_LANGUAGE, changeLanguage, languagePreference } from './index';

export default function LanguageSwitcher() {
  // Subscribes to language changes, which also move the preference below.
  const { t } = useTranslation();
  return (
    <TextField
      select
      size="small"
      label={t('common.language')}
      value={languagePreference()}
      onChange={(event) => changeLanguage(event.target.value)}
      sx={{ minWidth: 140, maxWidth: '100%', my: 1 }}
    >
      <MenuItem value={SYSTEM_LANGUAGE}>{t('common.languageSystem')}</MenuItem>
      <MenuItem value="ru" lang="ru">Русский</MenuItem>
      <MenuItem value="en" lang="en">English</MenuItem>
    </TextField>
  );
}
